import { Box, Container, styled } from "@mui/material";
import { CartoonCardAvatar } from "components/CartoonCard";
import SectionDivider from "./SectionDivider";

// Import images explicitly
import authorsImg from "assets/images/mascots/7_author.webp";
import tanksImg from "assets/images/mascots/21_tank_machine.webp";
import dobermanImg from "assets/images/mascots/25_doberman.webp";
import sincereImg from "assets/images/mascots/31_sincere.webp";
import wetImg from "assets/images/mascots/32_wet.webp";
import hamelinImg from "assets/images/mascots/3_hamelin.webp";
import rocketImg from "assets/images/mascots/41_rocket.webp";
import sleepImg from "assets/images/mascots/49_sleep.webp";
import tomatoImg from "assets/images/mascots/4_tomato.webp";
import wineImg from "assets/images/mascots/5_wine.webp";
import mustardImg from "assets/images/mascots/8_mustard.webp";
import superImg from "assets/images/mascots/8_super.webp";
import Slider from "react-slick";

// Import css files
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
// import Carousel, { CarouselDots, useCarousel } from "components/carousel";

const CustomSlider = styled(Slider)(({ theme, ownerState }) => ({
  ".slick-track": {
    // Show slick in one row
    display: "flex",
  },
  ".slick-list": {
    overflow: "visible",
    // margin: "0 15px",
  },
  "@media (min-width:600px)": {},
  "@media (min-width:900px)": {},
  "@media (min-width:1200px)": {
    ".slick-list": {
      overflow: "visible",
      // margin: "0 -27px",
    },
    ".slick-slide": {
      margin: "0 10px",
    },
  },
}));
// Dummy data for best farts
const bestFarts = [
  {
    id: 25,
    name: "The Doberman Fart",
    description: "It even attacks its owner.",
    image: dobermanImg,
    score: 450,
    backgroundColor: "#ffad33",
  },
  {
    id: 7,
    name: "Author's Fart",
    description: "It leaves the signature...",
    image: authorsImg,
    score: 876,
    backgroundColor: "#be864a",
  },
  {
    id: 31,
    name: "Sincere Fart",
    description:
      "The responsible of this kind of fart always confesses the crime. It's also known as 'idiot' fart.",
    image: sincereImg,
    score: 543,
    backgroundColor: "#fffbbc",
  },
  {
    id: 8,
    name: "The Machine Gun",
    description:
      "Fast sequence of farts with variant ratio that adds up into one. It's usual to observe shame on the culprit's face.",
    image: tanksImg,
    score: 789,
    backgroundColor: "#d2e5be",
  },
  {
    id: 21,
    name: "Mustard Gas",
    description:
      "Characterized by its sharp and silent sound. Only audible by the trained ears but lethal.",
    image: mustardImg,
    score: 654,
    backgroundColor: "#b6d106",
  },
  {
    id: 4,
    name: "Tomato Fart",
    description:
      "This is probably the most smelly fart by far. Its smell is basically nauseating, with a putrid touch that will frighten the devil.",
    image: tomatoImg,
    score: 921,
    backgroundColor: "#ff2605",
  },
  {
    id: 5,
    name: "Wine Spray Fart",
    description: "With sound and paint.",
    image: wineImg,
    score: 432,
    backgroundColor: "#c41c60",
  },
  {
    id: 32,
    name: "Wet Fart",
    description: "An uncomfortable one.",
    image: wetImg,
    score: 567,
    backgroundColor: "#66ebc2",
  },
  {
    id: 3,
    name: "Hamelin Flautist Fart",
    description: "It is like the trumpet fart, but it will call the mice.",
    image: hamelinImg,
    score: 345,
    backgroundColor: "#d59cde",
  },
  {
    id: 8,
    name: "Super Fart",
    description:
      "Besides being stinky, it is very long and noisy. Never throw one of those when people are sleeping because you will wake them up and they will probably beat you up.",
    image: superImg,
    score: 999,
    backgroundColor: "#fcee10",
  },
  {
    id: 49,
    name: "The Sleepwalker Fart",
    description: "Are you awake? This kind of fart only exists during sleep time.",
    image: sleepImg,
    score: 234,
    backgroundColor: "#bfe4e9",
  },
  {
    id: 41,
    name: "Rocket Fart",
    description: "Are you flying?? The typical altitude is about 15 meters.",
    image: rocketImg,
    score: 678,
    backgroundColor: "#fcbe01",
  },
];
function BestFarts({ id }) {
  // **React Slick Settings**
  const settings = {
    arrows: false,
    centerMode: true,
    centerPadding: "75px",
    cssEase: "ease",

    dots: false, // Hide pagination dots
    infinite: true, // Enable infinite scrolling
    speed: 500, // Transition speed
    slidesToShow: 5, // Show 4 slides at a time
    slidesToScroll: 1, // Scroll 1 slide at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Slide every 3 seconds
    pauseOnHover: true, // Pause on hover
    adaptiveHeight: false, // Keeps all slides the same height
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 3, slidesToScroll: 1 } }, // Large screens
      { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } }, // Medium-large screens (Desktop)
      { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } }, // Medium screens (Tablets & Small Laptops)
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } }, // Smaller Tablets
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } }, // Mobile landscape
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }, // Mobile portrait
    ],
  };

  return (
    <Box id={id} py={10} sx={{ position: "relative", width: "100%" }}>
      <Container maxWidth="xl">
        <SectionDivider title="Best Farts of All Time 💨🏆" withDivider />
      </Container>

      {/* Wrapper using full width */}
      <Box
        sx={{
          width: "100vw",
          maxWidth: "100%",
          overflow: "hidden",
          margin: "0 auto",
          padding: "40px 0",
        }}
      >
        <CustomSlider {...settings} className="custom-slider">
          {bestFarts.map((fart) => (
            <Box
              key={fart.id}
              px={1}
              sx={{
                // outline: "none",
                // display: "flex",
                // flexDirection: "column",
                // alignItems: "stretch", // Ensures all cards have the same height
                // height: "100%",
              }}
            >
              <CartoonCardAvatar
                name={fart.name}
                role=""
                description={fart.description}
                avatar={fart.image}
                backgroundColor={fart.backgroundColor}
                score={fart.score}
                tilt={true}
                baseTileAngle={0}
                endTiltAngle={-3}
                sx={{ height: "100%", width: "100%" }}
              />
            </Box>
          ))}
        </CustomSlider>
      </Box>
    </Box>
  );
}

export default BestFarts;
